import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './DataDeletion.css';

function DataDeletion() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Enable scrolling following the modal scrollbar pattern
  useEffect(() => {
    document.documentElement.classList.add('data-deletion-page');
    document.body.classList.add('data-deletion-page');

    return () => {
      document.documentElement.classList.remove('data-deletion-page');
      document.body.classList.remove('data-deletion-page');
    };
  }, []);

  return (
    <div className="page-container">
      <header className="header">
        <div className="header-content">
          <Link to="/" className="logo">EFSoft</Link>
          <button 
            className={`burger-menu ${isMenuOpen ? 'open' : ''}`} 
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <nav className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
            <Link to="/" className="nav-link">Home</Link>
          </nav>
        </div>
      </header>

          <div className="data-deletion-modal-body">
        <h1>Data Deletion Instructions</h1>
        <p className="subtitle">for EFSoft</p>

        <div className="introduction">
          <p>
            At EFSoft, we respect your right to control your personal data. If you wish to have your data deleted from our systems, please follow these steps:
          </p>
        </div>

        <section>
          <h2>Submit Your Request:</h2>
          <p>
            Email us at <a href="mailto:emil.filip@efsoft.co.uk">emil.filip@efsoft.co.uk</a> with your full name, any associated account or reference information, and a clear statement requesting the deletion of your personal data.
          </p>
        </section>

        <section>
          <h2>Verification Process:</h2>
          <p>
            To ensure the security of your information, we may ask you to verify your identity. This helps us confirm that the deletion request is legitimate.
          </p>
        </section>

        <section>
          <h2>Processing Your Request:</h2>
          <p>
            After verifying your identity, we will proceed to delete your data from our active systems. Please note that some data may be retained as required by law, for accounting, or regulatory purposes.
          </p>
        </section>

        <section>
          <h2>Confirmation:</h2>
          <p>
            We will notify you via email once your data has been successfully deleted.
          </p>
        </section>

        <section className="important-notice">
          <h2>Important Considerations:</h2>
          <ul>
            <li>Data deletion might affect your access to certain services on our website.</li>
            <li>The process may take up to 30 days to complete, depending on the complexity of your request and any legal obligations we have.</li>
          </ul>
        </section>

        <div className="contact-info">
          <p>
            If you have any questions or need further assistance regarding data deletion, please contact us at <a href="mailto:emil.filip@efsoft.co.uk">emil.filip@efsoft.co.uk</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default DataDeletion;
